// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "form .checkbox--with-label[data-v-42c98419]{display:block}form[data-v-42c98419] .input--error{margin-bottom:0!important}form .btn[data-v-42c98419]{text-transform:uppercase}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
